import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import CenterClassroomActions, { CenterClassroomRedux, CenterClassroomTypes } from '../Redux/CenterClassroomRedux'

const centerClassroomCrudObservable = createCRUDObservable({
  mainRedux: CenterClassroomRedux,
  reduxPath: 'centerClassroom',
  dataHandlers: {
    get: response => response.data.data,
  },
})

const getClassroomsEpic = (action$, store, { Api }) => (
  action$.ofType(CenterClassroomTypes.getClassroomRequest)
    .mergeMap(({ centerId }) => (
      Observable
        .fromPromise(Api.centerClassroom.get(centerId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              CenterClassroomActions.getClassroomError(response.error),
            ]
          }

          return [
            CenterClassroomActions.getClassroomSuccess(response.data.data),
          ]
        })
    ))
)

export const centerClassroomObservers = Object.assign({}, centerClassroomCrudObservable.observers, {})

export const centerClassroomEpic = combineEpics(
  centerClassroomCrudObservable.epic,
  getClassroomsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CenterClassroomObservable.js